import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import Dropdown from '../Dropdown/Dropdown';
import Textarea from '../Textarea-new/Textarea';
import Input from '../Input-new/Input';

const VerticalTableDragableCard = ({ column, headings, columnIndex, isEditable, isPrint,printTableColumns, handleChangeDropdown, handleChange, handleInputFocus, handlePrintKeyClick, handlePrintPagesDropDown, moveCard, handleKeyDown}) => {

    function renderInputElement({column, heading, isEditable, columnIndex, isPrint,printTableColumns, handleInputFocus}) {
        const id = `${heading.key}-${columnIndex}`;
        /** Hide NOI related fields if the checbox at top is unchecked**/
        if(column['autopopulate'] === undefined){
            (column['autopopulate']) = 1
        }
        const hideAutoPopulateKey = ['noi', 'noi_percentage', 'noi_multiplied', 'purchase_price'].includes(heading.key) && (!column['is_printable']) && (column['autopopulate']);
        switch (heading.format) {
            case 'dropdown':
                return <Dropdown
                    id={id}
                    theme='no-border'
                    viewClassName='vertical-table'
                    fillText={heading.dropdownType === 'loanquotes-amortization' ? ' Years' : ''}
                    optionsType={heading.dropdownType}
                    inputMode={true}
                    valueKey={id}
                    className='VerticalTable_input'
                    data={column}
                    value={column[heading.key]}
                    tooltip={heading.tooltip}
                    viewMode={!isEditable}
                    handleParentChange={handleChangeDropdown}
                    handleInputFocus = {()=>handleInputFocus(id)}
                    openOnFocus={true}
                />
                
            case 'textarea':
                return <Textarea
                    id={id}
                    classNameModifier="vertical-table"
                    theme='without-border'
                    className={`VerticalTable_input ${isPrint ? 'notesPrintsize' : '' } height56`}
                    name={id}
                    value={column[heading.key]}
                    viewMode={!isEditable}
                    tooltip={heading.tooltip}
                    handleParentChange={handleChange}
                    handleInputFocus = {()=>handleInputFocus(id)}
                />
            case 'checkbox':
                return <div className="print-control" style={{ display: "flex", justifyContent: "center", gap: "20px", paddingLeft: "24px" }}>
                    <input
                        type="checkbox"
                        name={`${heading.key}-${columnIndex}`}
                        key={`${heading.key}`} disabled={!isEditable}
                        value={column[heading.key]}
                        checked={column[heading.key]} 
                        onClick={e => handlePrintKeyClick(e, column, heading)}
                    />
                    {
                        isEditable ? (
                            <select className="custom_select" onChange={(e) => handlePrintPagesDropDown(+e.target.value, `print_page_number-${columnIndex}`)} value={column["print_page_number"]}>
                            <option value={1} disabled={printTableColumns.firstPagePrintColumns === 5}>1</option>
                        <option value={2} disabled={printTableColumns.secondPagePrintColumns ===5 || !printTableColumns.firstPagePrintColumns}>2</option>
                        <option value={3} disabled={printTableColumns.thirdPagePrintColumns ===5 || !printTableColumns.secondPagePrintColumns}>3</option>
                        <option value={4} disabled={printTableColumns.fourthPagePrintColumns ===5 || !printTableColumns.thirdPagePrintColumns}>4</option>
                        <option value={5} disabled={printTableColumns.fifthPagePrintColumns ===5 || !printTableColumns.fourthPagePrintColumns}>5</option>
                            </select>
                        ) : (
                            column["print_page_number"]
                        )
                    }
                </div>
            default:
                return <Input
                    id={id}
                    theme={`without-border ${column[heading.key] ? heading.key:''}`}
                    valueType={heading.format}
                  className={`VerticalTable_input ${heading.name.toLowerCase() === "loan structure" ? "loan_structure_val" : ''}`}
                    name={id}
                    value={hideAutoPopulateKey ?  ``:column[heading.key]}
                    isDollar={!hideAutoPopulateKey && heading.isDollar}
                    viewMode={!isEditable}
                    decimals={heading.decimals}
                    handleParentChange = {handleChange}
                    handleInputFocus = {()=>handleInputFocus(id)}
                    tooltip={heading.tooltip}
                    tooltipPosition='custom-down'
                />
        }
    }

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
        return {
        handlerId: monitor.getHandlerId(),
        }
    },
    hover(item, monitor) {
        if (!ref.current) {
        return
        }
        const dragIndex = item.index
        const hoverIndex = columnIndex

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
        return
        }

        // Time to actually perform the action
        moveCard(dragIndex, hoverIndex)

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        item.index = hoverIndex
    },
    })

    const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
        return { index: columnIndex }
    },
    collect: (monitor) => ({
        isDragging: monitor.isDragging(),
    }),
    })

    const opacity = isDragging ? 0 : 1
    drag(drop(ref))
    
  return (
    <div ref={ref} style={{ opacity, backgroundColor: 'white' }} data-handler-id={handlerId} onKeyDown={(e)=> handleKeyDown(e)} id={columnIndex}>
        {
            headings.map((heading, headingIndex) => (
                
                <div className={`VerticalTable_td ${headingIndex === 0 && 'paddingTop10 stickToTop top0'} ${headingIndex === 1 && 'stickToTop top40'} ${headingIndex === 2 && 'top20'} ${heading.name === 'Notes' && 'margineBottom30'}`} key={`${headingIndex}-${columnIndex}`} id={heading.key} >
                    {
                        renderInputElement({column, heading, isEditable, columnIndex, isPrint,printTableColumns, handleInputFocus})
                    }
                </div>
            ))
        }
    </div>
  )
}

export default VerticalTableDragableCard
